// Images
import galleryImg1 from "../assets/images/gallery/gallery-1.jpeg";
import galleryImg2 from "../assets/images/gallery/gallery-2.jpeg";
import galleryImg3 from "../assets/images/gallery/gallery-3.jpeg";
import galleryImg4 from "../assets/images/gallery/gallery-4.jpeg";
import galleryImg5 from "../assets/images/gallery/gallery-5.jpeg";
import galleryImg6 from "../assets/images/gallery/gallery-6.jpeg";
import galleryImg7 from "../assets/images/gallery/gallery-7.jpeg";
import galleryImg8 from "../assets/images/gallery/gallery-8.jpeg";
import galleryImg9 from "../assets/images/gallery/gallery-9.jpeg";
import galleryImg10 from "../assets/images/gallery/gallery-10.jpeg";
import galleryImg11 from "../assets/images/gallery/gallery-11.jpeg";
import galleryImg12 from "../assets/images/gallery/gallery-12.jpeg";
import galleryImg13 from "../assets/images/gallery/gallery-13.jpeg";
import galleryImg14 from "../assets/images/gallery/gallery-14.jpeg";
import galleryImg15 from "../assets/images/gallery/gallery-15.jpeg";
import galleryImg16 from "../assets/images/gallery/gallery-16.jpeg";
import galleryImg17 from "../assets/images/gallery/gallery-17.jpeg";
import galleryImg18 from "../assets/images/gallery/gallery-18.jpeg";
import galleryImg19 from "../assets/images/gallery/gallery-19.jpeg";
import galleryImg20 from "../assets/images/gallery/gallery-20.jpeg";
import galleryImg21 from "../assets/images/gallery/gallery-21.jpeg";
import galleryImg22 from "../assets/images/gallery/gallery-22.jpeg";
// import galleryImg23 from "../assets/images/gallery/gallery-23.jpeg";
import galleryImg24 from "../assets/images/gallery/gallery-24.jpeg";

export const galleryData = [
  {
    id: 1,
    type: "image",
    src: galleryImg1,
    alt: "Physiotherapy session",
  },
  {
    id: 2,
    type: "image",
    src: galleryImg2,
    alt: "Physiotherapy session",
  },
    {
    id: 3,
    type: "image",
    src: galleryImg3,
    alt: "Physiotherapy session",
  },
    {
    id: 4,
    type: "image",
    src: galleryImg4,
    alt: "Physiotherapy session",
  },
    {
    id: 5,
    type: "image",
    src: galleryImg5,
    alt: "Physiotherapy session",
  },
    {
    id: 6,
    type: "image",
    src: galleryImg6,
    alt: "Physiotherapy session",
  },
  {
    id: 7,
    type: "image",
    src: galleryImg7,
    alt: "Physiotherapy session",
  },
  {
    id: 8,
    type: "image",
    src: galleryImg8,
    alt: "Physiotherapy session",
  },
  {
    id: 9,
    type: "image",
    src: galleryImg9,
    alt: "Physiotherapy session",
  },
  {
    id: 10,
    type: "image",
    src: galleryImg10,
    alt: "Physiotherapy session",
  }, 
    {
    id: 11,
    type: "image",
    src: galleryImg11,
    alt: "Physiotherapy session",
  },    
    {
    id: 12,
    type: "image",
    src: galleryImg12,
    alt: "Physiotherapy session",
  }, 
    {
    id: 13,
    type: "image",
    src: galleryImg13,
    alt: "Physiotherapy session",
  }, 

  {
    id: 14,
    type: "image",
    src: galleryImg14,
    alt: "Physiotherapy session",
  }, 

    {
    id: 15,
    type: "image",
    src: galleryImg15,
    alt: "Physiotherapy session",
  }, 

    {
    id: 16,
    type: "image",
    src: galleryImg16,
    alt: "Physiotherapy session",
  }, 

  {
    id: 17,
    type: "image",
    src: galleryImg17,
    alt: "Physiotherapy session",
  }, 

  {
    id: 18,
    type: "image",
    src: galleryImg18,
    alt: "Physiotherapy session",
  }, 
  {
    id: 19,
    type: "image",
    src: galleryImg19,
    alt: "Physiotherapy session",
  }, 
  {
    id: 20,
    type: "image",
    src: galleryImg20,
    alt: "Physiotherapy session",
  }, 
    {
    id: 21,
    type: "image",
    src: galleryImg21,
    alt: "Physiotherapy session",
  }, 
    {
    id: 22,
    type: "image",
    src: galleryImg22,
    alt: "Physiotherapy session",
  }, 
    {
    id: 24,
    type: "image",
    src: galleryImg24,
    alt: "Physiotherapy session",
  }, 
];


export const galleryVideos = [
  {
    id: 3,
    type: "video",
    youtubeId: "YNNpGLwUfNk",
    title: "Activate Your Brain",
  },
  {
    id: 4,
    type: "video",
   youtubeId: "xFQ-iHJ1iSM",
    title: "Mid back pain Secrets",
  },
];